import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import InlineAlert from 'app/commonComponents/InlineAlert';
import { Alert } from './styles';

export function TicketInlineAlert({ children }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, []);

  return (
    <Alert ref={containerRef}>
      <InlineAlert
        style={{ width: 'auto', wordBreak: 'break-word' }}
        iconStyle={{ padding: '0.3rem' }}
        type="error"
      >
        {children}
      </InlineAlert>
    </Alert>
  );
}

TicketInlineAlert.propTypes = {
  children: PropTypes.string.isRequired,
};

export function TicketInlineAlerts({ errors }) {
  return errors
    .filter((error) => !!error)
    .map((error) => <TicketInlineAlert key={error}>{error}</TicketInlineAlert>);
}

TicketInlineAlerts.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};
